import * as React from "react";
import EventsFilterValueRenderers from "components/events/FilterValueRenderers";
import { OwnerCell, CategoryCell } from "security-app/components/SecurityEvents/Alerts/ColumnRenderers";
import RiskScoreRangeLabel from "security-app/components/SecurityEvents/Alerts/RiskScoreRangeLabel";
import AssociatedInvestigationsFilterLabel from "security-app/components/SecurityEvents/Alerts/AssociatedInvestigationsFilterLabel";
import AssociatedAssetLabel from "security-app/components/SecurityEvents/Alerts/AssociatedAssetLabel";
const FilterValueRenderers = {
  ...EventsFilterValueRenderers,
  owner: (value) => /* @__PURE__ */ React.createElement(OwnerCell, { owner: value }),
  category: (value) => /* @__PURE__ */ React.createElement(CategoryCell, { category: value }),
  scores: (value) => /* @__PURE__ */ React.createElement(RiskScoreRangeLabel, { value }),
  associated_investigations: (value) => /* @__PURE__ */ React.createElement(AssociatedInvestigationsFilterLabel, { invId: value }),
  associated_assets: (value) => /* @__PURE__ */ React.createElement(AssociatedAssetLabel, { assetId: value })
};
export default FilterValueRenderers;
